import React, { useMemo } from 'react';
import { sanitizeQuillHtml } from 'src/components/atoms/ReadOnlyRichText/sanitizeQuillHtml';
import 'react-quill-new/dist/quill.bubble.css';
import { Container } from './PreviewRichText.styles';

function cleanForPreview(html: string): string {
  let result = sanitizeQuillHtml(html);

  let prev = '';
  while (prev !== result) {
    prev = result;
    result = result.replace(
      /<li[^>]*>\s*(<br\s*\/?>)?\s*<\/li>\s*(<\/(ol|ul)>)/gi,
      '$2',
    );
  }

  result = result.replace(/(<p[^>]*>\s*(<br\s*\/?>)?\s*<\/p>\s*){2,}/gi, '');

  return result;
}

interface PreviewRichTextProps {
  value: string;
  'data-testid'?: string;
}

export const PreviewRichText: React.FC<PreviewRichTextProps> = React.memo(
  function PreviewRichText({ value, 'data-testid': dataTestId }) {
    const cleaned = useMemo(() => cleanForPreview(value), [value]);
    return (
      <Container
        className="ql-editor"
        data-testid={dataTestId}
        dangerouslySetInnerHTML={{ __html: cleaned }}
      />
    );
  },
);
